import styled from "styled-components";

export const ReportsDropdownStyle = styled.div`  .reports-dropdown-wrapper {
    position: relative;
    display: inline-block;
  }

  .reports-dropdown-button {
    width: auto;
    min-width: 120px;
    background-color: #f28809;
    border: 2px solid #f28809;
    border-radius: 8px;
    color: white;
    font-family: medium-pro, sans-serif;
    font-size: 1rem;
    padding: 12px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.3s ease;
    outline: none;
    box-shadow: 0 2px 8px rgba(242, 136, 9, 0.3);
    margin-right: 75px;

    &:hover {
      background-color: #e07d00;
      border-color: #e07d00;
      box-shadow: 0 4px 12px rgba(242, 136, 9, 0.4);
    }

    &:active {
      transform: translateY(1px);
    }

    i {
      margin-left: 8px;
      font-size: 0.8rem;
      transition: transform 0.3s ease;
    }

    &[aria-expanded="true"] i {
      transform: rotate(180deg);
    }
  }

  .reports-dropdown-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    z-index: 1002;
    overflow: hidden;
    min-width: 200px;
  }

  .reports-dropdown-item {
    padding: 12px 16px;
    font-family: thin-pro, sans-serif;
    font-size: 0.95rem;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: #f28809;
      color: white;
    }

    &:active {
      background-color: #e07d00;
    }
  }

  /* Remove any potential interference from other CSS */
  .reports-dropdown-wrapper * {
    box-sizing: border-box;
  }

  /* Ensure dropdown doesn't inherit unwanted styles */
  .reports-dropdown-wrapper {
    font-family: inherit;
    line-height: 1;
    margin: 0;
    padding: 0;
  }
`;
